var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTicketConfirmado = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.62939e-05 160H106.667V26.667H33.3334L7.62939e-05 58.413V160Z",
    fill: "#BBDEFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.76168 61.5874H34.9204V31.4287L4.76168 61.5874Z",
    fill: "#64B5F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 86.667H80.0001V94.286H26.6667V86.667ZM26.6667 101.905H67.4511V109.524H26.6667V101.905ZM26.6667 117.143H80.0001V124.762H26.6667V117.143ZM26.6667 132.381H67.4511V140H26.6667V132.381Z",
    fill: "#64B5F6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M160 40C160 62.09 142.09 80 120 80C97.91 80 80 62.09 80 40C80 17.91 97.91 0 120 0C142.09 0 160 17.91 160 40Z",
    fill: "#17CF63"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M141.206 21.2051L114.002 48.399L102.798 37.203L97.2036 42.797L114.002 59.603L146.798 26.7991L141.206 21.2051Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTicketConfirmado, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/TicketConfirmado.296e965b.svg";
export { ForwardRef as ReactComponent };